<template>
  <div class="st-select-field">
    <v-select v-bind="$attrs" :menu-props="resolvedMenuProps" v-on="$listeners">
      <template slot="selection" slot-scope="{ item, index, parent }">
        <v-tooltip v-if="index === 0" class="st-select__choice" top>
          <template v-slot:activator="{ on }">
            <span v-on="on" class="st-select">
              {{ item.text }}
            </span>
          </template>
          <span>{{ item.text }}</span>
        </v-tooltip>
        <v-tooltip v-else-if="index === 1" class="st-select__extra" top max-width="320">
          <template v-slot:activator="{ on }">
            <span class="st-select__more" v-on="on">
              (+{{ parent.selectedItems.length - 1 }} more)
            </span>
          </template>
          <div v-for="(selected, selectedIndex) in parent.selectedItems" :key="selectedIndex">
            {{ selected.text || selected }}
          </div>
        </v-tooltip>
      </template>
    </v-select>
  </div>
</template>

<style scoped>
.st-select-field /deep/ .v-select__selections {
  flex-wrap: nowrap;
  overflow: hidden;
}

.st-select-field /deep/ .st-select__choice {
  min-width: 0;
  overflow: hidden;
}

.st-select-field /deep/ .st-select__extra {
  flex-shrink: 0;
}

.st-select__more {
  color: rgba(0, 0, 0, 0.6);
  margin-left: 8px;
  white-space: nowrap;
}
</style>

<script>
import src from './src'
export default src
</script>
